import { GingerMediaBaseUrl } from "./baseUrls";
import { fetchWrapper } from "./fetchWrapper";

export interface AdvertisingGroupPayload {
  gmgAssetCode: string;
  audiName: string;
  seatingCapacity: number;
  screenCode: string;
}

export default function createAdvertisingGroups(data: any) {
  const url = `${GingerMediaBaseUrl}/createAdvertisingGroups`;

  return fetchWrapper(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: data,
  });
}
